import React from "react";

const NumPadItem = ({ className, dataCommand, onClick, children }) => {
  return (
    <li className={className} data-command={dataCommand} onClick={onClick}>
      {children}
    </li>
  );
};

export default NumPadItem;
